<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header Section -->
  <div class="mb-8">
    <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Activity Logs</h1>
        <p class="text-gray-600 mt-2">Monitor all administrative actions and system events</p>
      </div>
      <div class="flex gap-3">
        <p-button
          label="Refresh"
          icon="pi pi-refresh"
          [loading]="loading"
          (click)="refreshLogs()"
          styleClass="p-button-info"
        ></p-button>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <p-messages
    *ngIf="error"
    severity="error"
    [value]="[{ detail: error }]"
    class="mb-6"
  ></p-messages>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-12">
    <p-progressSpinner></p-progressSpinner>
    <p class="mt-4 text-gray-600">Loading activity logs...</p>
  </div>

  <!-- Table Section -->
  
    

    <p-table
      [value]="filteredLogs"
      [paginator]="true"
      [rows]="pageSize"
      [responsive]="true"
      [scrollable]="true"
      scrollHeight="600px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="createdAt" class="min-w-48">
            <div class="flex items-center gap-2">
              <i class="pi pi-clock"></i>
              Timestamp
              <p-sortIcon field="createdAt"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="action">
            <div class="flex items-center gap-2">
              <i class="pi pi-tag"></i>
              Action
              <p-sortIcon field="action"></p-sortIcon>
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-user"></i>
              User ID
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-layer-group"></i>
              Reference Type
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-key"></i>
              Reference ID
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-comment"></i>
              Message
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-globe"></i>
              IP Address
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2">
              <i class="pi pi-desktop"></i>
              User Agent
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log>
        <tr>
          <td class="font-mono text-sm text-gray-600">
            {{ formatDate(log.createdAt) }}
          </td>
          <td>
            <span class="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
              {{ log.action }}
            </span>
          </td>
          <td>
            <code class="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
              {{ log.userId || 'N/A' }}
            </code>
          </td>
          <td>
            <span class="px-2 py-1 bg-gray-100 rounded text-xs font-medium">
              {{ log.refType || '-' }}
            </span>
          </td>
          <td>
            <code class="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
              {{ log.refId || '-' }}
            </code>
          </td>
          <td class="max-w-xs truncate" [title]="log.message">
            {{ log.message }}
          </td>
          <td>
            <code class="px-2 py-1 bg-gray-100 rounded text-xs font-mono">
              {{ log.ipAddress || 'N/A' }}
            </code>
          </td>
          <td class="max-w-xs" [title]="log.userAgent || 'N/A'">
            <span class="text-xs text-gray-600">
              {{ (log.userAgent || 'N/A') | slice:0:30 }}{{ log.userAgent && log.userAgent.length > 30 ? '...' : '' }}
            </span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center py-8">
            <div class="flex flex-col items-center gap-4">
              <i class="pi pi-inbox text-4xl text-gray-400"></i>
              <div>
                <h4 class="text-lg font-medium text-gray-900 mb-2">No activity logs found</h4>
                <p class="text-gray-600">Try adjusting your filters or search criteria</p>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
</div>
